import createReducer from 'store/createReducer';
import * as types from './types';

const initialState = {
  loading: false,
  worksFields: [],
  cities: [],
  loadingCities: false,
  educationsLevel: [],
  loadingEducationsLevel: false,
  documentsTypes: [],
  loadingDocumentsTypes: false,
};

const SystemReducer = createReducer(initialState, {
  [types.GET_WORKS_FIELDS](state, action) {
    return {
      ...state,
      loading: true,
    };
  },
  [types.GET_WORKS_FIELDS_SUCCESS](state, action) {
    return {
      ...state,
      loading: false,
      worksFields: action.payload,
    };
  },
  [types.GET_WORKS_FIELDS_ERROR](state, action) {
    return {
      ...state,
      loading: false,
    };
  },

  [types.GET_CITIES](state, action) {
    return {
      ...state,
      loadingCities: true,
    };
  },
  [types.GET_CITIES_SUCCESS](state, action) {
    return {
      ...state,
      loadingCities: false,
      cities: action.payload,
    };
  },
  [types.GET_CITIES_ERROR](state, action) {
    return {
      ...state,
      loadingCities: false,
    };
  },

  [types.GET_EDUCATIONS_LEVEL](state, action) {
    return {
      ...state,
      loadingEducationsLevel: true,
    };
  },
  [types.GET_EDUCATIONS_LEVEL_SUCCESS](state, action) {
    return {
      ...state,
      loadingEducationsLevel: false,
      educationsLevel: action.payload,
    };
  },
  [types.GET_EDUCATIONS_LEVEL_ERROR](state, action) {
    return {
      ...state,
      loadingEducationsLevel: false,
    };
  },

  [types.GET_DOCUMENTS_TYPES](state, action) {
    return {
      ...state,
      loadingDocumentsTypes: true,
    };
  },
  [types.GET_DOCUMENTS_TYPES_SUCCESS](state, action) {
    return {
      ...state,
      loadingDocumentsTypes: false,
      documentsTypes: action.payload,
    };
  },
  [types.GET_DOCUMENTS_TYPES_ERROR](state, action) {
    return {
      ...state,
      loadingDocumentsTypes: false,
    };
  },
});

export default SystemReducer;
